/* Padding component meant as an escape hatch */
import React from "react";
import styled from "styled-components";

export default styled.div`
  padding: ${({ h = 0, v = 0 }) => `${v}rem ${h}rem`};

  ${props => props.theme.media.mobile`
    padding: ${({ h = 0, mh, mv, v = 0 }) =>
      `${mv || v / 2}rem ${mh || h / 4}rem`};
`};
`;



// WEBPACK FOOTER //
// ./src/components/blocks/Pad.js